import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgDownload = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.164 3c3.206 0 5.827 2.588 5.945 5.816l.004.242A3.148 3.148 0 0121 11.947c0 1.728-1.385 3.135-3.09 3.135h-2.514a.704.704 0 01-.7-.709c0-.39.313-.708.7-.708h2.515c.93 0 1.69-.77 1.69-1.718 0-.764-.5-1.434-1.208-1.647l-.238-.062a.708.708 0 01-.463-.74c.014-.147.022-.3.022-.457 0-2.55-2.042-4.624-4.55-4.624-2.02 0-3.819 1.38-4.374 3.355a.709.709 0 01-.336.427.689.689 0 01-.54.057c-.3-.093-.55-.135-.787-.135-1.503 0-2.728 1.243-2.728 2.772 0 1.529 1.224 2.772 2.728 2.772h1.917c.387 0 .7.317.7.709a.704.704 0 01-.7.708H7.127C4.85 15.082 3 13.202 3 10.892c0-2.31 1.85-4.188 4.127-4.188.174 0 .352.014.536.042l.095-.223C8.721 4.397 10.84 3 13.164 3zm-.054 10.233a.863.863 0 10-1.726 0v5.042l-1.129-1.072a.863.863 0 00-1.176-.012l-.058.056-.074.09a.787.787 0 00.102 1.022l2.527 2.401a.862.862 0 00.673.234.842.842 0 00.65-.234l2.527-2.4.04-.041a.787.787 0 00-.052-1.112l-.114-.092a.863.863 0 00-1.08.088l-1.11 1.053v-5.023z"
      clipRule="evenodd"
    />
  </svg>
));
SvgDownload.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgDownload;
